import React, { useState, useEffect } from "react";
import { Collapse, Container, NavbarToggler, NavLink } from "reactstrap";
import Scrollspy from "react-scrollspy";
import { Link } from "react-router-dom";
import blueQRLogo from "./qrmenu-logo-blue.svg"
import whiteQRLogo from "./qrmenu-logo-white.svg"
import { useLocation } from "react-router-dom";
import "./landingheader.css"
// Import Images
// import logodark from "../../../assets/images/logo-dark.png";
// import logolight from "../../../assets/images/logo-light.png";

const LandingHeader = ({removeBlur=false}) => {
  const [isOpenMenu, setisOpenMenu] = useState(false);
  const [navClass, setnavClass] = useState("");
  const location = useLocation();

  const toggle = () => setisOpenMenu(!isOpenMenu);

  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
  });

  const [activeLink, setActiveLink] = useState();

  useEffect(() => {
    const activation = (event) => {
      const target = event.target;
      if (target) {
        target.classList.add("active");
        setActiveLink(target);
        if (activeLink && activeLink !== target) {
          activeLink.classList.remove("active");
        }
      }
    };
    const defaultLink = document.querySelector('.navbar li a.active');
    if (defaultLink) {
      defaultLink?.classList.add("active");
      setActiveLink(defaultLink);
    }
    const links = document.querySelectorAll(".navbar a");
    links.forEach((link) => {
      link.addEventListener("click", activation);
    });
    return () => {
      links.forEach((link) => {
        link.removeEventListener("click", activation);
      });
    };
  }, [activeLink]);

  const scrollNavigation = () => {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setnavClass("is-sticky");
    } else {
      setnavClass("");
    }
  };

  return (
    <React.Fragment>
      <nav
        className={
          "navbar navbar-expand-lg navbar-landing fixed-top " + navClass
        } style={{backgroundColor: removeBlur ? "#FFFFFF" : "transparent" ,   backdropFilter: !removeBlur ? "none" : "blur(10px)",}}
        id="navbar"
      >
        <Container>
          {

            removeBlur ? (<Link className="navbar-brand " to="/index">
        
              <img
                src={blueQRLogo}
                className="card-logo"
                alt="logo light"
                height="30"
              />
            
            </Link>) : (
          <Link className="navbar-brand " to="/index">
          

          
            <img
              src={whiteQRLogo}
              // src={blueQRLogo}

              className="card-logo card-logo-dark "
              alt="logo dark"
              height="30"
            />
            <img
              src={blueQRLogo}
              className="card-logo card-logo-light"
              alt="logo light"
              height="30"
            />
          
          </Link>)

          }

          <NavbarToggler
            className="navbar-toggler py-0 fs-20 border-success text-white text-body"
            onClick={toggle}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="mdi mdi-menu text-success"></i>
          </NavbarToggler>

          <Collapse
            isOpen={isOpenMenu}
            className="navbar-collapse"
            id="navbarSupportedContent"
          >
            <Scrollspy
              offset={-18}
              items={[
                "hero",
                "services",
                "features",
                "plans",
                "reviews",
                "team",
                "contact",
              ]}
              currentClassName="active"
              className="navbar-nav mx-auto mt-2 mt-lg-0"
              id="navbar-example"
            >
              {/* <li className="nav-item">
                <NavLink className="fs-15 fw-semibold active" href="#hero">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold" href="#services">
                  Services
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold" href="#features">
                  Features
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold" href="#plans">
                  Plans
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold" href="#reviews">
                  Reviews
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold" href="#team">
                  Team
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="fs-15 fw-semibold" href="#contact">
                  Contact
                </NavLink>
              </li> */}
            </Scrollspy>

            <div className="d-flex justify-content-center align-items-center gap-3 text-dark">
              <Link
                to="/login"
                className="btn btn-success"
              >
                Sign in
              </Link>
              <Link to="/register" className="btn btn-primary">
                Sign Up
              </Link>
              
              {
                location?.pathname === "/top20" ? "": <Link to="/top20" className="text-white top20Nav" style={{cursor: "pointer"}}>
                Top Products
              </Link>
              }
             
            </div>

          </Collapse>


        </Container>
      </nav>
    </React.Fragment>
  );
};

export default LandingHeader;
